'use client';
import React from 'react';

import { InfiniteData, UseInfiniteQueryResult } from '@tanstack/react-query';

import { MagicWallCard, WallResponse } from '@shared/api/types/magicWall';
import { formatNumberLocalized } from '@shared/helpers/formatters';

import { useTransformData } from './hooks';
import InfiniteQueryState from './InfiniteQueryState';
import MagicOrderWallOffersList from './MagicOrderWallOffersList';
import StatInfo from './StatInfo';

type Props = {
  query: UseInfiniteQueryResult<InfiniteData<WallResponse, unknown>, unknown>;
  list: MagicWallCard[];
};

const MagicOrderWallActivity = ({ query, list }: Props) => {
  const transformData = useTransformData(query, list);

  const earnedSQR = transformData.meta?.earnedSQR
    ? formatNumberLocalized(transformData.meta?.earnedSQR)
    : 0;
  const earnedKarma = transformData.meta?.earnedKarma
    ? formatNumberLocalized(transformData.meta?.earnedKarma)
    : 0;

  return (
    <>
      <div className="flex gap-x-10 gap-y-5 justify-end my-8 max-sm:flex-col">
        <StatInfo className="w-full" label="Total Earned $SQR" value={`${earnedSQR} $SQR`} />
        <StatInfo className="w-full" label="Total Earned Karma" value={earnedKarma} />
      </div>

      <MagicOrderWallOffersList list={transformData.data} showStatus />

      <InfiniteQueryState query={query} />
    </>
  );
};

export default MagicOrderWallActivity;
